/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */

(function($) {

  // Use this variable to set up the common and page specific functions. If you
  // rename this variable, you will also need to rename the namespace below.
  var Sage = {
    // All pages
    'common': {
      init: function() {
        // JavaScript to be fired on all pages

        // Place amigos and make draggable
        var bodyWidth = $(window).width();
        var bodyHeight = $(window).height();
        $('.amigo').each(function() {
          var elementWidth = $(this).width();
          var elementHeight = $(this).height();
          var bodyWidth = $(window).width();
          var bodyHeight = $(window).height();
          var randPosX = Math.floor(Math.random()*(bodyWidth-elementWidth)/bodyWidth*100) + '%';
          var randPosY = Math.floor(Math.random()*bodyHeight*0.75) + 'px';
          $(this).css('top', randPosY).css('left', randPosX).removeClass('invisible');
        })
        .draggable();

        // Make aside draggable
        $('aside').draggable({
          stop: function(event, ui) {
            $.cookie('asideLeft', ui.position.left, { path: '/' });
            $.cookie('asideTop', ui.position.top, { path: '/' });
          }
        })
        .css({left : parseInt($.cookie('asideLeft')), top : parseInt($.cookie('asideTop'))})
        .removeClass('invisible');

        // Make imagen programa draggable
        $('.imagen-programa').draggable({
          stop: function(event, ui) {
            $.cookie('imagenLeft', ui.position.left, { path: '/' });
            $.cookie('imagenTop', ui.position.top, { path: '/' });
          }
        })
        .css({left : parseInt($.cookie('imagenLeft')), top : parseInt($.cookie('imagenTop'))})
        .removeClass('invisible');

        // Show submenu on hover
        $('ul#menu-navegacion>li').hoverIntent({
          over: function () {
            $(this).children('.sub-menu').show();
          }, 
          out: function () {
            $(this).children('.sub-menu').hide();
          },
          timeout: 200
        });

        // Position chat
        // $('#chat-container').css('bottom',$('#barra-elhc').outerHeight());
        // $(window).resize(function() {
        //   $('#chat-container').css('bottom',$('#barra-elhc').outerHeight());
        // });

      },
      finalize: function() {
        // JavaScript to be fired on all pages, after page specific JS is fired
      }
    },
    // Home page
    'home': {
      init: function() {
        // JavaScript to be fired on the home page
      },
      finalize: function() {
        // JavaScript to be fired on the home page, after the init JS
      }
    },
    // About us page, note the change from about-us to about_us.
    'about_us': {
      init: function() {
        // JavaScript to be fired on the about us page
      }
    }
  };

  // The routing fires all common scripts, followed by the page specific scripts.
  // Add additional events for more control over timing e.g. a finalize event
  var UTIL = {
    fire: function(func, funcname, args) {
      var fire;
      var namespace = Sage;
      funcname = (funcname === undefined) ? 'init' : funcname;
      fire = func !== '';
      fire = fire && namespace[func];
      fire = fire && typeof namespace[func][funcname] === 'function';

      if (fire) {
        namespace[func][funcname](args);
      }
    },
    loadEvents: function() {
      // Fire common init JS
      UTIL.fire('common');

      // Fire page-specific init JS, and then finalize JS
      $.each(document.body.className.replace(/-/g, '_').split(/\s+/), function(i, classnm) {
        UTIL.fire(classnm);
        UTIL.fire(classnm, 'finalize');
      });

      // Fire common finalize JS
      UTIL.fire('common', 'finalize');
    }
  };

  // Load Events
  $(document).ready(UTIL.loadEvents);

})(jQuery); // Fully reference jQuery after this point.
